import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

import { computed, ref, Ref, watch, withDefaults } from "vue";
import { DateTime } from "luxon";
import { extendSession } from "@/services/sessionExtensionService";
import TandemModal from "./TandemModal.vue";

interface Props {
  initialExpirationTime: string;
  warningTimes?: number[];
  allowSessionExtension?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SessionTimeoutWarning',
  props: {
    initialExpirationTime: {},
    warningTimes: { default: () => [60] },
    allowSessionExtension: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props;



const maxWarningTime = computed(() => Math.max(...props.warningTimes));

const currentTime = ref(DateTime.now());
const timerId = setInterval(() => {
  currentTime.value = DateTime.now();
}, 1000);

const expirationTime: Ref<DateTime> = ref(
  DateTime.fromISO(props.initialExpirationTime)
);
const timeLeft = computed(() => {
  const rawDiff = expirationTime.value.diff(
    currentTime.value,
    "seconds"
  ).seconds;
  const diff = Math.max(0, Math.min(maxWarningTime.value, rawDiff));
  return Math.floor(diff);
});
const timeLeftDisplay = computed(() => {
  const timeLeftValue = timeLeft.value;
  if (timeLeftValue >= 60) {
    const minutes = Math.floor(timeLeftValue / 60);
    const seconds = timeLeftValue % 60;
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  }
  return `${timeLeftValue} second${timeLeftValue == 1 ? "" : "s"}`;
});

const displayWarning = ref(timeLeft.value < maxWarningTime.value);
watch(timeLeft, (currentTimeLeft) => {
  if (props.warningTimes.includes(currentTimeLeft)) {
    displayWarning.value = true;
  }
});

const extendCurrentSession = async () => {
  if (expirationTime.value.isValid) {
    expirationTime.value = await extendSession();
  }
};
const closeModal = () => {
  displayWarning.value = false;
};
const reloadPage = () => {
  window.location.reload();
};

watch(
  () => [expirationTime.value.isValid, timeLeft.value == 0],
  ([timeIsValid, timeExpired]) => {
    if (!timeIsValid || timeExpired) {
      displayWarning.value = true;
      clearInterval(timerId);
    }
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TandemModal, {
    modelValue: displayWarning.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((displayWarning).value = $event)),
    "focus-trap": true,
    class: "modal show modal-survey"
  }, {
    title: _withCtx(() => [
      (timeLeft.value != 0)
        ? (_openBlock(), _createElementBlock("h1", _hoisted_1, " Your session is about to expire "))
        : (_openBlock(), _createElementBlock("h1", _hoisted_2, " Your session has expired "))
    ]),
    directions: _withCtx(() => [
      (timeLeft.value != 0)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode(" Your session will expire in " + _toDisplayString(timeLeftDisplay.value) + ". Once expired, any unsubmitted changes will be lost. ", 1)
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode(" All unsaved changes will be lost. You may close this message and copy / paste any answers you want to keep into an outside document before you proceed. ")
          ], 64))
    ]),
    buttons: _withCtx(() => [
      (timeLeft.value != 0)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_ctx.allowSessionExtension)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-burg",
                  type: "button",
                  onClick: extendCurrentSession
                }, " Extend Session "))
              : (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "btn",
                  type: "button",
                  onClick: closeModal
                }, " Close "))
          ], 64))
        : _createCommentVNode("", true),
      (timeLeft.value == 0)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("button", {
              class: "btn",
              type: "button",
              onClick: closeModal
            }, " Close "),
            _createElementVNode("button", {
              class: "btn btn-burg",
              type: "button",
              onClick: reloadPage
            }, " Log back in ")
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})